import { useMemo } from 'react';
import { getGraphQlContainsComparison } from 'utils/apolloUtils';
import { MemberPermissions, OperationType } from '__generated__/graphql';
import useSchedulingQueryParams from './useSchedulingQueryParams';
import { useSchedulingTimeRange } from './useSchedulingTimeRange';

export function useSchedulingTimeOffVariables() {
  const { memberId, positionId, memberGroupId } = useSchedulingQueryParams();

  const timeRange = useSchedulingTimeRange();

  return useMemo(
    () => ({
      first: 50,
      filter: {
        deletedOn: { isNull: true },
        dateStamp: {
          lessThanOrEqual: timeRange.endTime.toUTC().toISO({ suppressMilliseconds: true, includeOffset: false }),
          greaterThanOrEqual: timeRange.startTime.toUTC().toISO({ suppressMilliseconds: true, includeOffset: false }),
        },
        memberId: getGraphQlContainsComparison(memberId),
        member: {
          positionId: getGraphQlContainsComparison(positionId),
          memberGroupId: getGraphQlContainsComparison(memberGroupId),
          permissions: {
            permissions: [MemberPermissions.ManageTimeEntries],
            operationType: OperationType.And,
          },
        },
      },
      sort: [{ dateStamp: 'asc' }],
    }),
    [memberGroupId, memberId, positionId, timeRange.endTime, timeRange.startTime]
  );
}
